/** Keep the booked date visible while the Tasks tab occupies the quick-view body. */
import { VisitBrowseRow } from '@jms/model';
import { DateTime } from 'luxon';
import { defineConditionalTag } from '../../shared/define.conditional.tag';

export const visitDateTag = defineConditionalTag<VisitBrowseRow>(row => {

  const date = DateTime.fromISO(row.bookedDate ?? '', { zone: row.timezone });
  if (!date.isValid) return null;
  const original = DateTime.fromISO(row.localDate, { zone: row.timezone });
  const label = row.datesOverridden && original.isValid && original.toISODate() !== date.toISODate()
    ? `${original.toFormat('d LLL yyyy')} → ${date.toFormat('d LLL yyyy')}`
    : date.toFormat('d LLL yyyy');
  return { label, tone: 'neutral' };
});
